import { requestJson, buildQuery } from "./apiClient";

export function listClientOrganizations(params = {}) {
  return requestJson(`/api/admin/client-organizations${buildQuery(params)}`);
}

export function getClientOrganization(clientOrgId) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}`);
}

export function createClientOrganization(body) {
  return requestJson("/api/admin/client-organizations", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateClientOrganization(clientOrgId, body) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function listOrgClientUsers(clientOrgId) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/users`);
}

export function inviteOrgClientUser(clientOrgId, body) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/users/invite`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function listOrgViewAssignments(clientOrgId) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/views`);
}

export function listAvailableClientViews(clientOrgId, params = {}) {
  return requestJson(
    `/api/admin/client-organizations/${clientOrgId}/views/available${buildQuery(params)}`
  );
}

export function assignClientView(clientOrgId, body) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/views`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateViewAssignment(clientOrgId, assignmentId, body) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/views/${assignmentId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function removeViewAssignment(clientOrgId, assignmentId) {
  return requestJson(`/api/admin/client-organizations/${clientOrgId}/views/${assignmentId}`, {
    method: "DELETE",
  });
}

export function getOrgAuditLog(clientOrgId, params = {}) {
  return requestJson(
    `/api/admin/client-organizations/${clientOrgId}/audit-log${buildQuery(params)}`
  );
}

export function listAllClientUsers(params = {}) {
  return requestJson(`/api/admin/client-users${buildQuery(params)}`);
}

export function getClientUser(clientUserId) {
  return requestJson(`/api/admin/client-users/${clientUserId}`);
}

export function updateClientUser(clientUserId, body) {
  return requestJson(`/api/admin/client-users/${clientUserId}`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function updateClientUserStatus(clientUserId, body) {
  return requestJson(`/api/admin/client-users/${clientUserId}/status`, {
    method: "PATCH",
    body: JSON.stringify(body),
  });
}

export function resendClientUserInvitation(clientUserId) {
  return requestJson(`/api/admin/client-users/${clientUserId}/resend-invitation`, {
    method: "POST",
  });
}
